import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ZuiPortal, ZuiPopover } from '@zeiss/zui-react'
import config from 'app/config'
import { useToast } from 'hooks'
import { set } from 'features/file-view/fileSlice'
import { refresh } from 'features/auth/authSlice'

import './index.css'

const CustomModal = () => {
    return ReactDOM.createPortal(
        <ZuiPortal name="test">
            <ZuiPopover></ZuiPopover>
        </ZuiPortal>,
        document.body
    )
}

const Dashboard = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [notifyCount, setNotifyCount] = useState(1)
    const { toast } = useToast()

    const [showDate, setShowDate] = useState(true)

    const handlePush = id => {
        dispatch(
            set([
                {
                    id: 'ef3e0db8-7335-4ec2-a3c0-1803f614801c',
                    hdpFileId: '61f6c74449eab51630452555',
                    url: 'https://i.pinimg.com/originals/46/46/0e/46460e3e43b3f88a9f5ba0545c726257.jpg',
                    contentType: 'image',
                },
                {
                    id: '11a350b0-8a5b-4818-a161-7de40a066247',
                    hdpFileId: '61f6cb9049eab5163045255a',
                    url: 'https://wallpaper.dog/large/20492929.jpg',
                    contentType: 'image',
                },
                {
                    id: 'fef24858-94f2-472f-87ad-b8d24141dd44',
                    hdpFileId: '61f6cd5149eab5163045255f',
                    // url: 'https://www.olympus-imaging.co.in/content/000101300.jpg',
                    url: 'https://nikonrumors.com/wp-content/uploads/2014/03/Nikon-1-V3-sample-photo.jpg',
                    contentType: 'image',
                },
                // {
                //     id: "d05f3d01-3fea-4a92-8093-0bf7530c3f9f",
                //     hdpFileId: '618e0ba699c16d6018c98513',
                //     streamingUrl: 'https://nikonrumors.com/wp-content/uploads/2014/03/Nikon-1-V3-sample-photo.jpg',
                //     contentType: 'video'
                // },
                {
                    id: 'd05f3d01-3fea-4a92-8093-0bf7530c3f9f-3',
                    hdpFileId: '61c03e196bcd0e0ba059bebf',
                    streamingUrl:
                        'https://nikonrumors.com/wp-content/uploads/2014/03/Nikon-1-V3-sample-photo.jpg',
                    contentType: 'video',
                },
                {
                    id: 'd05f3d01-3fea-4a92-8093-0bf7530c3f9f-',
                    hdpFileId: '618e0da499c16d6018c98543',
                    streamingUrl:
                        'https://nikonrumors.com/wp-content/uploads/2014/03/Nikon-1-V3-sample-photo.jpg',
                    contentType: 'video',
                },
                {
                    id: 'd05f3d01-3fea-4a92-8093-0bf7530c3f9f-5',
                    hdpFileId: '62971edd2144844ab02b2f75',
                    streamingUrl:
                        'https://nikonrumors.com/wp-content/uploads/2014/03/Nikon-1-V3-sample-photo.jpg',
                    contentType: 'video',
                },
                {
                    id: 'd05f3d01-3fea-4a92-8093-0bf7530c3f9f-9',
                    hdpFileId: '6298949f2144844ab02e76ff',
                    streamingUrl:
                        'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
                    contentType: 'video',
                },
                // {
                //     id: 'd05f3d01-3fea-4a92-8093-0bf7530c3f9f-2',
                //     hdpFileId: '618e0da499c16d6018c98543-2',
                //     streamingUrl: 'https://www.youtube.com/watch?v=v3dclL2grbs',
                //     contentType: 'video',
                // },
            ])
        )
        // history.push('/files/' + id)
        history.push({
            pathname: '/files/' + id,
            key: id,
        })
    }

    const refreshToken = () => {
        dispatch(refresh())
    }

    const notify = () => {
        toast.success('Notification ' + notifyCount)
        setNotifyCount(n => n + 1)
    }

    return (
        <div>
            <p>Build Number: {config.BUILD_NUMBER}</p>
            <button onClick={() => handlePush('61f6c74449eab51630452555')}>Image 1</button>
            <button onClick={() => handlePush('61f6cb9049eab5163045255a')}>Image 2</button>
            <button onClick={() => handlePush('61f6cd5149eab5163045255f')}>Image 3</button>
            {/* <button onClick={() => handlePush('618e0ba699c16d6018c98513')}
            {/* <button onClick={() => handlePush('6298949f2144844ab02e76ff')}
            >Image 4
            </button> */}

            {/* <button onClick={() => handlePush('61c03e196bcd0e0ba059bebf')}>Stream 1</button>
            <button onClick={() => handlePush('618e0da499c16d6018c98543')}>Stream 2</button> */}
            <button onClick={() => handlePush('62971edd2144844ab02b2f75')}>Dev Stream </button>
            <button onClick={() => handlePush('6298949f2144844ab02e76ff')}>QA Stream </button>
            <div style={{ marginTop: '50px' }}>
                <button onClick={() => refreshToken()}>Refresh token</button>
            </div>
            <button onClick={notify}>Toast</button>

            {/*       <button onClick={() => handlePush('618e0da499c16d6018c98543-1')}>MP4</button>
            <button onClick={() => handlePush('618e0da499c16d6018c98543-2')}>Youtube</button> */}

            <div style={{ border: '1px solid red', position: 'relative' }}>
                {/* <zui-date-picker-input
                    locale="en-US"
                    placeholderDay="DD"
                    placeholderMonth="MM"
                    placeholderYear="YYYY"
                ></zui-date-picker-input> */}
                <zui-button>Button</zui-button>
                <zui-overlay-directive placements="top-start" portal="test"></zui-overlay-directive>
            </div>
            {/* <CustomModal /> */}

            {/* <ZuiPortal name="test">
                <ZuiPopover>
                   
                </ZuiPopover>
            </ZuiPortal> */}

            {/* <div className="date-wrapper">
                <div className="date-input">
                    <zui-date-picker-input
                        locale="en-US"
                        placeholderDay="DD"
                        placeholderMonth="MM"
                        placeholderYear="YYYY"
                    ></zui-date-picker-input>
                </div>
                <div className="date-picker">
                   
                </div>
            </div> */}

            {/*
            <zui-date-picker-input
                locale="en-US"
                placeholderDay="DD"
                placeholderMonth="MM"
                placeholderYear="YYYY"
            ></zui-date-picker-input> */}
            {/*
            <div style={{ background: '#fff' }}>
                <zui-date-picker
                    close-on-date-selected
                    disabled-days-of-week="Mo,Tuesday"
                    locale="en-US"
                    max="2010-01-01T00:00:00.000+01:00"
                    min="2020-12-31T23:59:59.999+01:00"
                ></zui-date-picker>
            </div> */}
            {/* <div className="dialog-content-wrap">
                                <Input
                                    noLabel
                                    name="name"
                                    type="textfield"
                                    placeholder={t('collection.title')}
                                />
                            </div> */}
        </div>
    )
}

export default Dashboard
